// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messaging {
  margin-bottom: 15px;
}

/** Error Styling **/
.messaging .error {
  margin-top: 2rem;
}

.messaging .error header {
  border-bottom: 2px solid #ff3500;
  padding-top: 1rem;
  padding-bottom: 1.1rem;
  margin-left: 0;
  margin-right: 0;
  font-size: 32px;
  font-weight: bold;
  color: #ff3500;
  display: flex;
  justify-content: space-between;
}

.messaging .error .body {
  border-bottom: 1px solid #ff3500;
  padding-top: 1rem;
  color: #ff3500;
}

/* Success Styling */
.messaging .success {
  margin-top: 2rem;
}

.messaging .success header {
  border-bottom: 2px solid #4f8a10;
  padding-top: 1rem;
  padding-bottom: 1.1rem;
  margin-left: 0;
  margin-right: 0;
  font-size: 32px;
  font-weight: bold;
  color: #4f8a10;
  display: flex;
  justify-content: space-between;
}

.messaging .success .body {
  border-bottom: 1px solid #4f8a10;
  padding-top: 1rem;
  color: #4f8a10;
}

/* Warning Styling */
.messaging .warning {
  margin-top: 2rem;
}

.messaging .warning header {
  border-bottom: 2px solid #f2c779;
  padding-top: 1rem;
  padding-bottom: 1.1rem;
  margin-left: 0;
  margin-right: 0;
  font-size: 32px;
  font-weight: bold;
  color: #f2c779;
  display: flex;
  justify-content: space-between;
}

.messaging .warning .body {
  border-bottom: 1px solid #f2c779;
  padding-top: 1rem;
  color: #feefb3;
}

/** Micro stying **/
.error.micro {
  border-bottom: none;
  margin: 0px;
}

.error.micro header {
  font-size: 16px;
}

.error.micro .body {
  padding-top: 1rem;
  color: #ff3500;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/messaging.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".messaging {\n  margin-bottom: 15px;\n}\n\n/** Error Styling **/\n.messaging .error {\n  margin-top: 2rem;\n}\n\n.messaging .error header {\n  border-bottom: 2px solid #ff3500;\n  padding-top: 1rem;\n  padding-bottom: 1.1rem;\n  margin-left: 0;\n  margin-right: 0;\n  font-size: 32px;\n  font-weight: bold;\n  color: #ff3500;\n  display: flex;\n  justify-content: space-between;\n}\n\n.messaging .error .body {\n  border-bottom: 1px solid #ff3500;\n  padding-top: 1rem;\n  color: #ff3500;\n}\n\n/* Success Styling */\n.messaging .success {\n  margin-top: 2rem;\n}\n\n.messaging .success header {\n  border-bottom: 2px solid #4f8a10;\n  padding-top: 1rem;\n  padding-bottom: 1.1rem;\n  margin-left: 0;\n  margin-right: 0;\n  font-size: 32px;\n  font-weight: bold;\n  color: #4f8a10;\n  display: flex;\n  justify-content: space-between;\n}\n\n.messaging .success .body {\n  border-bottom: 1px solid #4f8a10;\n  padding-top: 1rem;\n  color: #4f8a10;\n}\n\n/* Warning Styling */\n.messaging .warning {\n  margin-top: 2rem;\n}\n\n.messaging .warning header {\n  border-bottom: 2px solid #f2c779;\n  padding-top: 1rem;\n  padding-bottom: 1.1rem;\n  margin-left: 0;\n  margin-right: 0;\n  font-size: 32px;\n  font-weight: bold;\n  color: #f2c779;\n  display: flex;\n  justify-content: space-between;\n}\n\n.messaging .warning .body {\n  border-bottom: 1px solid #f2c779;\n  padding-top: 1rem;\n  color: #feefb3;\n}\n\n/** Micro stying **/\n.error.micro {\n  border-bottom: none;\n  margin: 0px;\n}\n\n.error.micro header {\n  font-size: 16px;\n}\n\n.error.micro .body {\n  padding-top: 1rem;\n  color: #ff3500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
